import { BaseAnchor, BaseVersion } from 'src/models/anchor-and-version/base.model';
import { Component, ViewChild } from '@angular/core';
import { CrudBaseModalComponent } from './crud-base-modal.component';

@Component({
    template: '',
    // eslint-disable-next-line @angular-eslint/prefer-standalone
    standalone: false,
})
export abstract class CrudModalAbstractComponent<
    TAnchor extends BaseAnchor<TVersion>,
    TVersion extends BaseVersion,
> {
    @ViewChild('baseModal') public baseModal!: CrudBaseModalComponent<TAnchor, TVersion>;

    public get form() {
        return this.baseModal?.form;
    }

    public get isModalVisible() {
        return this.baseModal?.isModalVisible;
    }

    public set isModalVisible(value: boolean) {
        this.baseModal.isModalVisible = value;
    }

    public onOpen(): void {
        this.baseModal?.onOpen();
    }

    public async save(): Promise<TAnchor | TVersion> {
        return this.baseModal.save();
    }

    public async saveAndClose(): Promise<void> {
        return this.baseModal.saveAndClose();
    }
}
